import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 47 47",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M41.3 6.1c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5c-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7S46 10.9 46 8.3s-2.1-4.7-4.7-4.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M9 8.9c-2 0-3.7-1.6-3.7-3.7S7 1.5 9 1.5s3.7 1.6 3.7 3.7S11 8.9 9 8.9zM9 4c-.7 0-1.2.6-1.2 1.2S8.3 6.4 9 6.4s1.2-.5 1.2-1.2S9.6 4 9 4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M14.9 46c-2 0-3.7-1.6-3.7-3.7 0-2 1.6-3.7 3.7-3.7s3.7 1.6 3.7 3.7c0 2-1.7 3.7-3.7 3.7zm0-4.9c-.6 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2 1.2-.5 1.2-1.2-.6-1.2-1.2-1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M37.8 38c1.5 0 2.7 1.2 2.7 2.7s-1.2 2.7-2.7 2.7-2.7-1.2-2.7-2.7 1.2-2.7 2.7-2.7m0-2.5c-2.9 0-5.2 2.3-5.2 5.2s2.3 5.2 5.2 5.2 5.2-2.3 5.2-5.2-2.3-5.2-5.2-5.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M24.8 6.7c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4m0-2.5c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-3-6.5-6.5-6.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M38.2 18.9c1.3 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5m0-2.5c-2.7 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.3-5-5-5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M4.3 33.2c.4 0 .7.4.7.8s-.3.8-.8.8-.7-.4-.7-.8.3-.8.8-.8m0-2.5C2.5 30.7 1 32.2 1 34s1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3-1.5-3.3-3.3-3.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M24.2 24.4c3 0 5.4 2.4 5.4 5.4s-2.4 5.4-5.4 5.4-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4m0-2.5c-4.4 0-7.9 3.6-7.9 7.9s3.6 7.9 7.9 7.9 7.9-3.6 7.9-7.9-3.6-7.9-7.9-7.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M8.2 17.4c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6S4.6 23 4.6 21s1.6-3.6 3.6-3.6m0-2.5c-3.3 0-6.1 2.7-6.1 6.1s2.7 6 6.1 6 6.1-2.7 6.1-6.1-2.8-6-6.1-6z"
		})
	]
});
export default SvgIcon;
